import { getJSON } from '@folklore/fetch';
import { UseQueryOptions, keepPreviousData, useQuery } from '@tanstack/react-query';
import isEmpty from 'lodash/isEmpty';
import queryString from 'query-string';

import type { Page } from '../types/entities';

// Type Definitions
export interface PageQueryConfig extends Omit<UseQueryOptions<Page>, 'queryKey' | 'queryFn'> {
    query?: Record<string, unknown> | null;
    locale?: string | null;
    locales?: string[] | null;
}

function usePage(path: string, { query = null, ...config }: PageQueryConfig = {}) {
    const key = ['pages', path, query];
    const { locale: configLocale = 'fr', locales: configLocales = null } = config || {};
    const locale = configLocale || 'fr';
    const locales = configLocales || ['fr', 'en'];

    const {
        data: page = null,
        status = null,
        isLoading = false,
        isError = false,
        isFetching = false,
        refetch,
        ...otherProps
    } = useQuery({
        queryKey: key,
        queryFn: ({ queryKey: [, pathname, query] }) =>
            getJSON(
                `${pathname === '/' || locales.map((loc) => `/${loc}`).includes(pathname) ? locale || 'fr' : pathname}.json${
                    !isEmpty(query)
                        ? `?${queryString.stringify(query, { arrayFormat: 'bracket' })}`
                        : ''
                }`,
            ),
        // suspense: false,
        retry: 1,
        placeholderData: keepPreviousData,
        ...config,
    });

    return {
        ...otherProps,
        page: page ?? null,
        isLoading,
        isError,
        status,
        loading: !isError && (isFetching || isLoading),
        refetch,
    };
}

export default usePage;
